<h2 mat-dialog-title>
  <mat-icon color="warn" style="vertical-align: middle; margin-right: 8px;">warning</mat-icon>
  Session Timeout Warning
</h2>

<mat-dialog-content>
  <p class="countdown-text">
    For your security, you will be automatically logged out due to inactivity in:
  </p>
  <div class="countdown-display">
    <span class="countdown-time">{{ formattedCountdown }}</span>
  </div>
  <p class="action-text">
    Would you like to stay logged in?
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="logout()" color="warn">
    Logout Now
  </button>
  <button mat-raised-button color="primary" (click)="stay()">
    <mat-icon>check_circle</mat-icon>
    Stay Logged In
  </button>
</mat-dialog-actions>
